import {
  Component,

} from '@angular/core';
import { DatePipe} from '@angular/common';
import {MessageService} from 'primeng/api';
import {DialogService} from 'primeng/dynamicdialog';
import {GisFieldsComponent} from '@app/pages/electronic-field-map/pages/gis-fields/gis-fields';
import {DateFormatLangPipe} from '@app/utils/pipes/date-format-lang-pipe';

@Component({
  selector: 'app-gis-page',
  standalone: true,
  imports: [

    GisFieldsComponent,
  ],
  providers: [
    MessageService,
    DatePipe,
    DateFormatLangPipe,
    DialogService
  ],
  templateUrl: './gis-request.html',
  styleUrls: ['./gis-request.scss']
})
export class GisRequestComponent{
}
